<template>
  <div class="mj_page flex jb">
    <div class="left_area">
      <div class="left_top">
        <div class="scrollable-content">
          <div class="toolsIntroduce">
            <div class="right">
              <div>
                人脸滤镜
              </div>
              <span>
                智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果。
              </span>
            </div>
          </div>
          <div class="describe">
            <div class="refer_title">
              <div></div>
              上传图片（必填）
            </div>
            <div class="Reference_image"
                 v-loading="upmjloading"
                 element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload
                  class="upload-demo"
                  drag
                  :action="fileApi+'/api/front/upload/?fdir=mj_tool'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  accept="image/jpeg, image/png, image/bmp"
                  multiple>
                <div v-if="form.iw_url" class="yesUpload">
                  <img :src="form.iw_url" alt="" class="yesUpload_img">
                  <div class="yesUpload_icon" @click.stop="form.iw_url=''">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-else class="noUpload">
                  <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                  <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                  <div> 只能上传jpg/png文件，且不超过3MB</div>
                </div>
              </el-upload>
            </div>
          </div>
          <div class="describe">
            <div class="refer_title">
              <div></div>
              高级参数
            </div>
            <div class="parameter">
              <!--              <div class="parameter_title">-->
              <!--                美颜人数-->
              <!--              </div>-->
              <!--              <div class="parameter_slider">-->
              <!--                <div class="slider">-->
              <!--                  <el-slider :min="25" :max="35" v-model="form.multi_face"></el-slider>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="parameter_title">
                滤镜系数
              </div>
              <div class="parameter_slider">
                <div class="slider">
                  <el-slider :min="0" :max="1" :step="0.1" v-model="form.strength"></el-slider>
                </div>
              </div>
            </div>
          </div>
          <div class="describe" >
            <div class="refer_title">
              <div></div>
              风格选择
            </div>
            <div class="toolsModelList">
              <div class="music_style">
                <span :class="clickImgStyle.sign===item.sign?'spanColor':''"
                      v-for="item in musicStyle"
                      @click="clickLoraStyleList(item)">
                  {{ item.style }}
                </span>
              </div>
              <!--              <div class="music_styleImg" :style="{height:expand?270+'px':'auto'}">-->
              <div class="music_styleImg" :style="{height:clickImgStyle.shou?expand?270+'px':'auto':'auto'}">
                <div @click="listClick(item,'list1')"
                     :class="clickImgStyle.num===item.num? 'item_click':'styleImg_item'"
                     v-for="item in clickImgStyleList" v-if="item.sign.includes(clickImgStyle.sign) ">
                  <img alt="" :src="item.src">
                  <div>
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div class="upDown" @click="expand=!expand" v-if="clickImgStyle.shou">
                <img v-if="expand" alt="" src='./img/down2.png' height="14" width="15"/>
                <img v-if="!expand" alt="" src="./img/upward.png" height="13" width="14"/>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 参数
      form: {
        // 上传图片
        iw_url:'',
        resource_type:'10001', //
        strength:0.5,
      },
      // 上传图片
      fileApi: FILE_API_SERVER,
      upmjloading:false,
      clickImgStyle: {num: 1, sign: 1, shou: false,},
      clickImgStyleList: [
        {num: 1, type:'10001', sign: [1], title: '白茶', select: false, scale: 0.8, src: require('./EmitFacefilter/1.webp'),},
        {num: 2, type:'10002', sign: [1], title: '白皙', select: false, scale: 0.8, src: require('./EmitFacefilter/2.webp'),},
        {num: 3, type:'10003', sign: [1], title: '初夏', select: false, scale: 0.8, src: require('./EmitFacefilter/3.webp'),},
        {num: 4, type:'10004', sign: [1], title: '东京', select: false, scale: 0.8, src: require('./EmitFacefilter/4.webp'),},
        {num: 5, type:'10005', sign: [1], title: '告白', select: false, scale: 0.8, src: require('./EmitFacefilter/5.webp'),},
        {num: 6, type:'10006', sign: [1], title: '阳光', select: false, scale: 0.8, src: require('./EmitFacefilter/6.webp'),},
        {num: 7, type:'10007', sign: [1], title: '玫瑰', select: false, scale: 0.8, src: require('./EmitFacefilter/7.webp'),},

        {num: 8, type:'10008', sign: [2], title: '清晰', select: false, scale: 0.8, src: require('./EmitFacefilter/8.webp'),},
        {num: 9, type:'10009', sign: [2], title: '水晶', select: false, scale: 0.8, src: require('./EmitFacefilter/9.webp'),},
        {num: 10, type:'10010', sign: [2], title: '薄荷', select: false, scale: 0.8, src: require('./EmitFacefilter/10.webp'),},
        {num: 11, type:'10011', sign: [2], title: '基础', select: false, scale: 0.8, src: require('./EmitFacefilter/11.webp'),},
        {num: 12, type:'10012', sign: [2], title: '心动', select: false, scale: 0.8, src: require('./EmitFacefilter/12.webp'),},

        {num: 13, type:'10013', sign: [3], title: '哑灰', select: false, scale: 0.8, src: require('./EmitFacefilter/13.webp'),},
        {num: 14, type:'10014', sign: [3], title: '樱桃布丁', select: false, scale: 0.8, src: require('./EmitFacefilter/14.webp'),},
        {num: 15, type:'10015', sign: [3], title: '自然', select: false, scale: 0.8, src: require('./EmitFacefilter/15.webp'),},
        {num: 16, type:'10016', sign: [3], title: '优雅', select: false, scale: 0.8, src: require('./EmitFacefilter/16.webp'),},
        {num: 17, type:'10017', sign: [3], title: '黑白', select: false, scale: 0.8, src: require('./EmitFacefilter/17.webp'),},
        {num: 18, type:'10018', sign: [3], title: '水果', select: false, scale: 0.8, src: require('./EmitFacefilter/18.webp'),},
        {num: 19, type:'10019', sign: [3], title: '爱情', select: false, scale: 0.8, src: require('./EmitFacefilter/19.webp'),},
        {num: 20, type:'10020', sign: [3], title: '冬天', select: false, scale: 0.8, src: require('./EmitFacefilter/20.webp'),},
        {num: 21, type:'10021', sign: [3], title: '照片', select: false, scale: 0.8, src: require('./EmitFacefilter/21.webp'),},
        {num: 22, type:'10022', sign: [4], title: '夏天', select: false, scale: 0.8, src: require('./EmitFacefilter/22.webp'),},
        {num: 23, type:'10023', sign: [4], title: '芬芳', select: false, scale: 0.8, src: require('./EmitFacefilter/23.webp'),},
        {num: 24, type:'10024', sign: [4], title: '魅力', select: false, scale: 0.8, src: require('./EmitFacefilter/24.webp'),},
        {num: 25, type:'10025', sign: [4], title: '悸动', select: false, scale: 0.8, src: require('./EmitFacefilter/25.webp'),},
        {num: 26, type:'10026', sign: [4], title: '海滩', select: false, scale: 0.8, src: require('./EmitFacefilter/26.webp'),},
        {num: 27, type:'10027', sign: [4], title: '街拍', select: false, scale: 0.8, src: require('./EmitFacefilter/27.webp'),},
        {num: 28, type:'10028', sign: [4], title: '甜蜜', select: false, scale: 0.8, src: require('./EmitFacefilter/28.webp'),},
        {num: 29, type:'10029', sign: [4], title: '初吻', select: false, scale: 0.8, src: require('./EmitFacefilter/29.webp'),},
        {num: 30, type:'10030', sign: [4], title: '午后', select: false, scale: 0.8, src: require('./EmitFacefilter/30.webp'),},
        {num: 31, type:'10031', sign: [4], title: '活力', select: false, scale: 0.8, src: require('./EmitFacefilter/31.webp'),},
        {num: 32, type:'10032', sign: [4], title: '朦胧', select: false, scale: 0.8, src: require('./EmitFacefilter/32.webp'),},
        {num: 33, type:'10033', sign: [4], title: '快乐', select: false, scale: 0.8, src: require('./EmitFacefilter/33.webp'),},
        {num: 34, type:'10034', sign: [4], title: '时尚', select: false, scale: 0.8, src: require('./EmitFacefilter/34.webp'),},
        {num: 35, type:'10035', sign: [5], title: '泡沫', select: false, scale: 0.8, src: require('./EmitFacefilter/35.webp'),},
        {num: 36, type:'10036', sign: [5], title: '柠檬', select: false, scale: 0.8, src: require('./EmitFacefilter/36.webp'),},
        {num: 37, type:'10037', sign: [5], title: '棉花糖', select: false, scale: 0.8, src: require('./EmitFacefilter/37.webp'),},
        {num: 38, type:'10038', sign: [5], title: '溪流', select: false, scale: 0.8, src: require('./EmitFacefilter/38.webp'),},
        {num: 39, type:'10039', sign: [5], title: '美丽', select: false, scale: 0.8, src: require('./EmitFacefilter/39.webp'),},
        {num: 40, type:'10040', sign: [5], title: '咖啡', select: false, scale: 0.8, src: require('./EmitFacefilter/40.webp'),},
        {num: 41, type:'10041', sign: [5], title: '温柔', select: false, scale: 0.8, src: require('./EmitFacefilter/41.webp'),},
        {num: 42, type:'10042', sign: [5], title: '激情', select: false, scale: 0.8, src: require('./EmitFacefilter/42.webp'),},
        {num: 43, type:'10043', sign: [5], title: '温暖', select: false, scale: 0.8, src: require('./EmitFacefilter/43.webp'),},
        {num: 44, type:'10044', sign: [5], title: '早餐', select: false, scale: 0.8, src: require('./EmitFacefilter/44.webp'),},
        {num: 45, type:'10045', sign: [5], title: '清茶', select: false, scale: 0.8, src: require('./EmitFacefilter/45.webp'),},
        {num: 46, type:'10046', sign: [5], title: '晴朗', select: false, scale: 0.8, src: require('./EmitFacefilter/46.webp'),},

        {num: 47, type:'10047', sign: [6], title: '圣洁', select: false, scale: 0.8, src: require('./EmitFacefilter/47.webp'),},
        {num: 48, type:'10048', sign: [6], title: '森林', select: false, scale: 0.8, src: require('./EmitFacefilter/48.webp'),},
        {num: 49, type:'10049', sign: [6], title: '冲浪', select: false, scale: 0.8, src: require('./EmitFacefilter/49.webp'),},
        {num: 50, type:'10050', sign: [6], title: '牛奶咖啡', select: false, scale: 0.8, src: require('./EmitFacefilter/50.webp'),},
        {num: 51, type:'10051', sign: [6], title: '清晰的', select: false, scale: 0.8, src: require('./EmitFacefilter/51.webp'),},

        {num: 52, type:'10052', sign: [6], title: '微风', select: false, scale: 0.8, src: require('./EmitFacefilter/52.webp'),},
        {num: 53, type:'10053', sign: [6], title: '日落', select: false, scale: 0.8, src: require('./EmitFacefilter/53.webp'),},
        {num: 54, type:'10054', sign: [6], title: '鲜艳', select: false, scale: 0.8, src: require('./EmitFacefilter/54.webp'),},
        {num: 55, type:'10055', sign: [6], title: '日式', select: false, scale: 0.8, src: require('./EmitFacefilter/55.webp'),},

        {num: 56, type:'10056', sign: [6], title: '星光', select: false, scale: 0.8, src: require('./EmitFacefilter/56.webp'),},
        {num: 57, type:'10057', sign: [6], title: '阳光', select: false, scale: 0.8, src: require('./EmitFacefilter/57.webp'),},
        {num: 58, type:'10058', sign: [6], title: '落叶', select: false, scale: 0.8, src: require('./EmitFacefilter/58.webp'),},
        {num: 59, type:'10059', sign: [6], title: '活力', select: false, scale: 0.8, src: require('./EmitFacefilter/59.webp'),},
        {num: 60, type:'10060', sign: [6], title: '恋人', select: false, scale: 0.8, src: require('./EmitFacefilter/60.webp'),},
        {num: 61, type:'10061', sign: [6], title: '典雅', select: false, scale: 0.8, src: require('./EmitFacefilter/61.webp'),},

        {num: 62, type:'10062', sign: [7], title: '春天', select: false, scale: 0.8, src: require('./EmitFacefilter/62.webp'),},
        {num: 63, type:'10063', sign: [7], title: '罗马', select: false, scale: 0.8, src: require('./EmitFacefilter/63.webp'),},
        {num: 64, type:'10064', sign: [7], title: '绿色', select: false, scale: 0.8, src: require('./EmitFacefilter/64.webp'),},
        {num: 65, type:'10065', sign: [7], title: '微风', select: false, scale: 0.8, src: require('./EmitFacefilter/65.webp'),},

        {num: 66, type:'10066', sign: [7], title: '暖心', select: false, scale: 0.8, src: require('./EmitFacefilter/66.webp'),},
        {num: 67, type:'10067', sign: [7], title: '海水', select: false, scale: 0.8, src: require('./EmitFacefilter/67.webp'),},
        {num: 68, type:'10068', sign: [7], title: '神秘', select: false, scale: 0.8, src: require('./EmitFacefilter/68.webp'),},
        {num: 69, type:'10069', sign: [7], title: '典型1', select: false, scale: 0.8, src: require('./EmitFacefilter/69.webp'),},
        {num: 70, type:'10070', sign: [7], title: '典型2', select: false, scale: 0.8, src: require('./EmitFacefilter/70.webp'),},

        {num: 71, type:'10071', sign: [7], title: '雪白', select: false, scale: 0.8, src: require('./EmitFacefilter/71.webp'),},
        {num: 72, type:'10072', sign: [7], title: '阳光', select: false, scale: 0.8, src: require('./EmitFacefilter/72.webp'),},
        {num: 73, type:'10073', sign: [7], title: '浮云', select: false, scale: 0.8, src: require('./EmitFacefilter/73.webp'),},
        {num: 74, type:'10074', sign: [7], title: '流丽', select: false, scale: 0.8, src: require('./EmitFacefilter/74.webp'),},
        {num: 75, type:'10075', sign: [7], title: '电影', select: false, scale: 0.8, src: require('./EmitFacefilter/75.webp'),},
        {num: 76, type:'10076', sign: [7], title: '怀旧', select: false, scale: 0.8, src: require('./EmitFacefilter/76.webp'),},
        {num: 77, type:'10077', sign: [7], title: '奶酪', select: false, scale: 0.8, src: require('./EmitFacefilter/77.webp'),},
        {num: 78, type:'10078', sign: [7], title: '蝴蝶', select: false, scale: 0.8, src: require('./EmitFacefilter/78.webp'),},
      ],
      musicStyle: [
        {style: '滤镜一', sign: 1, num: 1, shou:false ,resource_type:'10001',},
        {style: '滤镜二', sign: 2, num: 8, shou: false,resource_type:'10008',},
        {style: '滤镜三', sign: 3, num: 13, shou:false ,resource_type:'10013',},
        {style: '滤镜四', sign: 4, num: 22, shou:false ,resource_type:'10022',},
        {style: '滤镜五', sign: 5, num: 35, shou:false ,resource_type:'10035',},
        {style: '滤镜六', sign: 6, num: 47, shou:false ,resource_type:'10047',},
        {style: '滤镜七', sign: 7, num: 62, shou:false ,resource_type:'10062',},
      ],
      expand: true,

    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    listClick(item){
      this.clickImgStyle.num=item.num
      this.form.resource_type=item.type
    },
    clickLoraStyleList(item, modle) {

      this.clickImgStyle.sign = item.sign
      this.clickImgStyle.num = item.num
      this.clickImgStyle.shou = item.shou
      this.form.resource_type = item.resource_type
    },
    // 上传图片
    handleAvatarSuccess(res,) {
      this.upmjloading = false
      if(res.data.error !== ''){
        this.$message.error(res.data.error);
        return
      }
      this.form.iw_url = res.data.file_full_url;
    },
    beforeAvatarUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const { width, height } = img;
          // const isValidResolution =  width <= 4096 &&  height <= 4096;
          const isValidResolution = width >= 10 && width <= 2000 && height >= 10 && height <= 2000;


          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
            reject({ isValidType: false });
            return
          }

          if (!isLt3M) {
            this.$message.error('上传文件大小不能超过 3MB!');
            reject({ isLt3M: false });
            return
          }

          if (!isValidResolution) {
            // this.$message.error('图片分辨率需小于 4096x4096 像素!');
            this.$message.error('图片分辨率需大于 10x10 像素且小于 2000x2000 像素!');
            reject({ isValidResolution: false });
            return
          }

          resolve({ isValidType, isLt3M, isValidResolution, });
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({ isImageValid: false });
        };
        this.upmjloading = true
      });
    },

  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}


.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
  display: flex;
  //align-items: center;
  //justify-content: center;
}

.left_area {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .createButton {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid #36373d;

    div {
      font-size: 16px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;

      span {
        font-size: 12px;
      }
    }
  }

  .left_top {
    height: calc(100% - 76px);
    //overflow-y: auto;
    .goBack {
      margin: 5px 0 15px 0;
      font-size: 14px;
      color: #fff;
      display: flex;

      .iconFont {
        display: flex;
        margin-right: 20px;

        div {
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          width: 16px;
          margin-right: 5px;

          img {
            width: 100%;
            //height: 100%;
            vertical-align: top;
            opacity: 1;
          }
        }
      }

      .font_title {
        font-weight: 700;
      }

    }
  }

  .left_nav {
    padding: 4px 0;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #36373d;
    display: flex;
    align-items: center;

    color: #fff;

    div {
      flex: 1;
      text-align: center;
      margin: 0 4px;
      cursor: pointer;
    }

    .navSelected {
      background-color: #5865f2;
      border-radius: 4px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  .scrollable-content {
    overflow-y: auto;
    height: calc(100% - 120px);
    margin: 10px 0;
    color: #fff;

    .toolsIntroduce {
      background-color: #1e1f22;
      padding: 16px 14px;
      display: flex;
      border-radius: 5px;

      .left {
        margin-right: 12px;
        width: 20px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .right {
        flex: 1;


        div {
          font-size: 14px;
          font-weight: 700;
          height: 20px;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          line-height: 20px;
        }

      }
    }

    .describe {
      .refer_title {
        height: 18px;
        margin: 15px 0;
        display: flex;
        align-items: center;
        font-size: 14px;

        div {
          height: 100%;
          border: 2px solid #5865f2;
          border-radius: 2px;
          margin-right: 5px;
        }
      }

      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;

        .upload-demo {
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 280px;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }

        }
      }

      .toolsModelList {

        .music_style {
          overflow-x: auto;
          width: 100%;
          white-space: nowrap;
          padding: 0 0 5px 0;

          span {
            font-size: 14px;
            margin-right: 15px;
            cursor: pointer;

          }

          .spanColor {
            color: #5865f2;
          }
        }
        .music_style::-webkit-scrollbar {
          height: 5px !important;
        }

        .music_styleImg {
          padding: 0 0 0 0;
          display: flex;
          flex-wrap: wrap;

          //height: 270px;
          overflow: hidden;
          gap: 5px 10px;

          .styleImg_item {
            width: 83px;
            height: 83px;
            position: relative;
            border: 2px solid #5865f200;
            border-radius: 5px;
            overflow: hidden;
            margin: 2px 0;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;

            }

          }

          .item_click {
            border: 2px solid #5865f2;
            width: 83px;
            height: 83px;
            position: relative;
            border-radius: 5px;
            margin: 2px 0;
            cursor: pointer;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }

        .upDown {
          background-color: #1e1f22;
          padding: 5px 0;
          display: flex;
          cursor: pointer;

          img {
            margin: 0 auto;
          }
        }

      }
      .parameter {
        width: 100%;
        padding: 15px 15px;
        border-radius: 6px;
        background-color: #1d2027;
        font-size: 14px;
        overflow: hidden;

        .parameter_title {
          margin: 0 0 5px 0;
        }

        .parameter_slider {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .slider_num {
            width: 40px;
            height: 28px;
            background-color: #2d313b;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;

          }

          .slider {
            flex: 1;
            margin: 0 0 0 10px;

            /deep/ .el-slider__bar {
              background-color: #5865f2;
            }

            /deep/ .el-slider__button {
              border-color: #FFF;
              cursor: grab;
            }
          }
        }

        .Negative_Prom {
          .Negative_text {
            width: 100%;
            height: 50px;
            background-color: #313338;
            border: 2px solid #393c43;
            color: #c7d2c9;
            padding: 5px 5px;
            font-size: 14px;
            border-radius: 4px;
          }

          textarea::placeholder {
            color: #a8abb2; /* 将颜色改为灰色 */
          }

        }
      }
      .music_style::-webkit-scrollbar {
        height: 5px !important;
      }

    }
  }
}


.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}




.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;



    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}


.create_error {
  width: 190px;
  height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 64px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}


.Image_manipulation {
  //width: 500px;
  background-color: #3f3c3a;
  padding: 20px 20px;
  border-radius: 4px;
  position: relative;

  .clear {
    position: absolute;
    top: 0;
    right: 0;
    //background-color: #5865f2;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-icon-error {
      font-size: 20px;
      color: #565658;
    }
  }

  .clear:hover {
    background-color: #343538;
  }
}



.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

</style>